/**
 * Generates date radio inputs based on configuration from host element.
 *
 * The host element has the following data attributes:
 * - data-today-open: server decided if today is open (boolean)
 * - data-enabled-days: array of enabled days (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
 * - data-days-in-advance: number of days in advance to show (integer)
 * - data-label-template: selector for the label template (string)
 * - data-disabled-dates: array of disabled dates in YYYY-MM-DD format (string[])
 * - data-required: whether selection is required (boolean)
 * - data-cart-property: name of the cart property to set (string)
 * - data-technical-cart-property: name of the cart property to set with technical date value (string)
 *
 * The label template should be a <template> element containing the HTML structure for each label.
 * It can use the following placeholders:
 * - {dayName}: full name of the day (e.g., "Monday")
 * - {formattedDate}: formatted date string (e.g., "January 1, 2023")
 */

import { createDeliveryDateApp } from "@nx-paeonia/feature-product-configurator";
import { GlobalEvents } from "./domain/global-events.enum.js";

document.addEventListener("DOMContentLoaded", createDeliveryDateApp);
document.body.addEventListener(GlobalEvents.ProductConfiguratorReinitialized, createDeliveryDateApp);
